import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';
import InGroupComp from './TeamFormation/InGroupComp';
import NotInGroupComp from './TeamFormation/NotInGroupComp';
// import { useSelector } from 'react-redux';

const TeamFormation = (props) => {
  return (
    <div className="team-formation mt-3">
      {
        props.inGroup ?
          <InGroupComp
            setTeamMembers={props.setTeamMembers}
            setInGroup={props.setInGroup}
            setTeamName={props.setTeamName}
            teamName={props.teamName}
            teamNumber={props.teamNumber}
            facilitatorName={props.facilitatorName}
            teamMembers={props.teamMembers}
            teamFormationLocked={props.teamFormationLocked}
            teamMembershipLocked={props.teamMembershipLocked}
          />
          : <NotInGroupComp
            setTeamMembers={props.setTeamMembers}
            setInGroup={props.setInGroup}
            setTeamName={props.setTeamName}
            assignTeam={props.assignTeam}
            teamFormationLocked={props.teamFormationLocked}
          />
      }
    </div>
  )
}

export default TeamFormation
